import React from "react";
import clinicimage from "../../assets/Contact Us/ContactusDesktop.png";

const clinics = [
  {
    name: "Arambh Rehabilitation and Deaddiction Center",
    address:
      "Sai sapphire building,B1, 2nd floor ,near Anand nagar, Kasarvadvali,  Ovale, Thane West, 400615 ",
    adressLink: "https://maps.app.goo.gl/8c5ZEDHACWRKnwGw5",
    phone : "9004401820 | 9004496820 | 9004439820",
    email: "care.arambhrehab@gmail.com",
    timing: "Everyday - Morning 10 am to 1 pm",
  },
  {
    name: "Happy Solutions Clinic",
    address:
      "101, Rashi Tower, Next to Ryan International School, Gokuldham, Goregaon (E) Mumbai - 400063",
    adressLink: "https://maps.app.goo.gl/BGFAcwqMccqBEw1g8",
    phone: "8655355300 | 9137366210",
    email: "care.arambhrehab@gmail.com",
    timing: "Everyday - Evening 6 pm to 9 pm",
  },
];

export default function OurClinic() {
  return (
    <section className="w-full  py-12 grid md:grid-cols-2 gap-10 items-start">
      {/* max-w-[1280px] mx-auto px-6 */}
      {/* Left Column: Image */}
      <div className="w-full">
        <img
          src={clinicimage}
          alt="Helping Hands"
          className="md:w-[546px] md:h-[575px]  w-[342px] h-[375px]  rounded-lg object-cover"
        />
      </div>

      {/* Right Column: Clinic Info */}
      <div className="flex flex-col ">
        <h2 className="mb-[24px] font-garamond-subheading md:text-[32px] sm:text-[32px] text-[#2C3075]">
          Find a clinic close to you
        </h2>

        {clinics.map((clinic, i) => (
          <div key={i} className=" ">
            <hr className="border-[#2C3075] " />
            <h3 className="font-generalsans-subheading text-[#2C3075] md:mt-[32px]  md:mb-[60px] my-[24px]">
              {clinic.name}
            </h3>

            {/* Desktop view: address | phone */}
            <div className="hidden md:grid md:grid-cols-2 font-generalsans-description text-[#2C3075]  md:text-[14px] sm:text-[14px]  md:gap-4  mb-[32px]">
              <p>
                <span className="font-semibold">Address: </span>
                <a href={clinic.adressLink}>{clinic.address}</a>
              </p>
              <p>
                <span className="font-semibold">Phone Number: </span>
                {clinic.phone.split("|").map((num, index) => (
                  <a
                    key={index}
                    href={`tel:${num.trim()}`}
                    className="text-[#2C3075] hover:underline mr-2"
                  >
                    {num.trim()}
                    {index !== clinic.phone.split("|").length - 1 && " | "}
                  </a>
                ))}
              </p>
              <p>
                <span className="font-semibold">Email: </span>
                {clinic.email}
              </p>
              <p>
                <span className="font-semibold">OPD Timing: </span>
                {clinic.timing}
              </p>
            </div>

            {/* Mobile view: stacked */}
            <div className="grid md:hidden gap-[12px] font-generalsans-description text-[#2C3075]  md:text-[14px] sm:text-[14px] mb-[24px]">
              <p>
                <span className="font-semibold">Address: </span>
                {clinic.address}
              </p>
              <p>
                <span className="font-semibold">Email: </span>
                {clinic.email}
              </p>
              <p>
                <span className="font-semibold">Phone Number: </span>
                {clinic.phone.split("|").map((num, index) => (
                  <a
                    key={index}
                    href={`tel:${num.trim()}`}
                    className="text-[#2C3075] hover:underline mr-2"
                  >
                    {num.trim()}
                    {index !== clinic.phone.split("|").length - 1 && " | "}
                  </a>
                ))}
              </p>
              <p>
                <span className="font-semibold">OPD Timing: </span>
                {clinic.timing}
              </p>
            </div>

            {/* Divider */}
            {i !== clinics.length - 1 && <hr className="border-gray-300" />}
          </div>
        ))}
      </div>
    </section>
  );
}
